module.exports = __webpack_public_path__ + "img/clock.1d781882.svg";